import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import base64 from "base-64";
import axios from "../../axios";
import { Background, OTPInputComponent } from "../Login/LoginComp";
import { FloatLabelInput, LoadingButton } from "../../Utils/CustomComponent";
// import useAuth from "../../auth/hooks/useAuth";
import { oracleConfig } from "../../Utils/constant";
import urls from "../../Utils/urls";
// import { useSelector } from "react-redux";

const PayoffLogin = ({
  title = "Request Payoff",
  text = "Welcome! Please enter your email address to proceed.",
}) => {
  const [otpEntered, setOtpEntered] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const recaptchaRef = useRef(null);
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const email = searchParams.get("id");
  const encodedRequestId = searchParams.get("id2");
  const emailValue = watch("email");

  useEffect(() => {
    if (location.pathname?.includes("/payoff-gateway-authorize")) {
      if (!email || !isValidBase64(email) || !encodedRequestId) {
        navigate("/unauthorize-payoff-access", {
          state: {
            displayPage: true,
          },
        });
      }
      if (email && isValidBase64(email)) {
        const updatedEmail = base64.decode(email);
        if (isValidEmail(updatedEmail)) {
          setValue("email", updatedEmail);
          const decodedRequestId = base64.decode(encodedRequestId);
          setRequestId(decodedRequestId);
        }
      }
    }
  }, [email, setValue, location.pathname]);

  const isValidBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };
  const isValidEmail = (email) => {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
  };

  const isValidEmailValue =
    isValidBase64(email) && isValidEmail(base64.decode(email));

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  async function handleInitialLogin(email) {
    if (!captchaToken) {
      alert("Please complete the CAPTCHA");
      return;
    }
    setDisableBtn(true);

    try {
      const res2 = await axios.get(
        urls.manageApiKey.recapthcaForVOM(captchaToken),
      );

      if (res2?.data?.success) {
        const data = {
          email_address: email,
        };

        if (location.pathname?.includes("/payoff-gateway-authorize")) {
          const payload = {
            request_id: requestId,
            emailaddress: email,
          };

          const res3 = await axios.post(
            urls.payOffDemand.validateExternalBorrower,
            payload,
            oracleConfig,
          );
        }
        const res = await axios.post(urls.account.sendOtp, data, oracleConfig);

        if (res.status === 200 || res.status === "200") {
          setIsOtpStage(true);
          setShowOtpInput(true);
          setDisableBtn(false);
        } else {
          // console.log(res);
          // setPromptFail("Invalid email.");
          setDisableBtn(false);
        }
      } else {
        alert("CAPTCHA verification failed ❌");
      }
    } catch (error) {
      console.error(error);
      if (error?.config?.url === urls.payOffDemand.validateExternalBorrower) {
        navigate("/invalid-payoff-link", {
          state: {
            displayPage: true,
          },
        });
      }
    }
  }

  async function onSubmit(data) {
    setPromptFail("");
    try {
      if (isOtpStage) {
        setAfterOtpLoading(true);
        const newData = {
          email_address: data.email,
          otp: otpEntered,
        };
        // console.log({ newData });
        const res = await axios.post(
          // urls.account.validateOtp,
          urls.payOffDemand.validateOTP,
          newData,
          oracleConfig,
        );
        // console.log({res})
        if (res.status === 200 || res.status === "200") {
          localStorage.setItem("payoff_token", res?.data?.tokenForPayoff);
          localStorage.setItem("email_for_payoff", data.email);

          setAfterOtpLoading(false);
          if (location.pathname?.includes("/payoff-gateway-authorize")) {
            navigate(`/authorize-requests`, {
              state: {
                authorizedBorrower: true,
              },
            });
          } else {
            navigate(`/payoff-requests`);
          }
        } else {
          setPromptFail("Invalid OTP! Please try again.");
          setAfterOtpLoading(false);
        }
      } else {
        handleInitialLogin(data.email);
      }
    } catch (error) {
      console.error(error);
      setPromptFail("Invalid OTP! Please try again.");
    } finally {
      setAfterOtpLoading(false);
    }
  }

  return (
    <Background showFooter={false}>
      <form className="w-75">
        <h3>{title}</h3>
        <p className="pb-5 mb-3">{text}</p>

        <div className="form-outline mb-5">
          <FloatLabelInput
            register={{
              ...register("email", {
                required: true,
                pattern:
                  // eslint-disable-next-line no-useless-escape
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }),
            }}
            label={"Email"}
            value={watch("email")}
            error={errors.email ? "Email Required" : ""}
            type="email"
            disabled={isValidEmailValue}
          />
        </div>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={"6LdCWmgsAAAAAD2OfKz0DqvanPavGilPc7oq9hlW"}
          onChange={handleCaptchaChange}
        />

        <div className="form-outline mb-1">
          {showOtpInput && (
            <>
              <OTPInputComponent
                setOtpEntered={setOtpEntered}
                setOtpReceived={() => {}}
                onClick={() => handleInitialLogin(emailValue)}
              />
            </>
          )}
        </div>

        <div className="text-center pt-1 mt-5 mb-5 pb-1">
          {showOtpInput ? (
            <LoadingButton
              className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
              type="button"
              onClick={handleSubmit(onSubmit)}
              title={"Verify OTP and Continue"}
              disabled={afterOtpLoading || otpEntered?.length !== 6}
              loading={afterOtpLoading}
            />
          ) : (
            <LoadingButton
              className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
              type="button"
              onClick={handleSubmit(onSubmit)}
              // onClick={handleContinueClick}
              disabled={disableBtn}
              loading={disableBtn}
              title={"Continue"}
            />
          )}

          {promptFail ? (
            <div className="alert alert-error" role="alert">
              {promptFail}
            </div>
          ) : null}
          <br />
        </div>
      </form>
    </Background>
  );
};

export default PayoffLogin;
